require("../css/main.scss");
window.$ = window.jQuery = require("jquery");
require("bootstrap");
require("lightgallery");
require("lg-thumbnail");
require("./slick");
require("./nav-scroll");
require("./ken-burns");
require("../img/logo-moben.svg");
// require("../img/logo-footer.svg");
require("../img/logo-linkomweb.png");
require("../img/insta.png");

$(document).ready(() => {
  $(".lightgallery").lightGallery({
    selector: ".slick-slide .gallery-item:not(.slick-cloned .gallery-item)",
    fullScreen: false,
    toogleThumb: true,
    share: false,
    download: false,
    autoplayControls: false,
    actualSize: false,
    autoplayFirstVideo: true,
    youtubePlayerParams: {
      modestbranding: 1,
      showinfo: 0,
      rel: 0,
    },
    iframeMaxWidth: "70%",
  });
});

$("body").on("mouseenter mouseleave", ".navbar-nav > .dropdown", function(e) {
  var _d = $(e.target).closest(".navbar-nav > .dropdown");
  _d.addClass("show");

  setTimeout(function() {
    _d[_d.is(":hover") ? "addClass" : "removeClass"]("show");
  }, 300);
});

$(".label-container").click(function() {
  $header = $(this);

  $header.toggleClass("closed");

  //getting the next element
  $content = $header.next();
  //open up the content needed - toggle the slide- if visible, slide up, if not slidedown.
  $content.slideToggle(500, function() {});
});
